// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { PAYMENT_OPTION_LIST_CLASS_NAME } from "../../../../core/constants/className";
import { Icon } from "../../../../../../io/hyperify/frontend/components/icon/Icon";
import {
    AktiaLogo,
    AlandsbankenLogo,
    DanskeBankLogo,
    HandelsbankenLogo,
    MastercardLogo,
    MobilepayLogo,
    NordeaLogo,
    OmaSaastopankkiLogo,
    OpLaskuLogo,
    OsuuspankkiLogo,
    PayTrailImage,
    PivoLogo,
    PopPankkiLogo,
    SaastopankkiLogo,
    SiirtoLogo,
    SPankkiLogo,
    VisaLogo
} from "../../../assets/paytrail";
import "./PaymentOptionList.scss";

export interface PaymentOptionListProps {
    readonly className ?: string;
}

export function PaymentOptionList (props: PaymentOptionListProps) {
    const className = props?.className;
    return (
        <div className={
            PAYMENT_OPTION_LIST_CLASS_NAME
            + (className? ` ${className}` : '')
        }>
            <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-image`}><img
                src={PayTrailImage}
                alt={"Paytrail"}
            /></Icon>
            <div className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logos`}>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><VisaLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><MastercardLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><MobilepayLogo /></Icon>
                {/*<Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><ApplePayLogo /></Icon>*/}
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><PivoLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><SiirtoLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><OpLaskuLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><AktiaLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><DanskeBankLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><OsuuspankkiLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><SaastopankkiLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><AlandsbankenLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><HandelsbankenLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><NordeaLogo /></Icon>
                {/*<Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><AmericanExpressLogo /></Icon>*/}
                {/*<Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><JoustoLogo /></Icon>*/}
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><OmaSaastopankkiLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><PopPankkiLogo /></Icon>
                <Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><SPankkiLogo /></Icon>
                {/*<Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><WalleyLogo /></Icon>*/}
                {/*<Icon className={`${PAYMENT_OPTION_LIST_CLASS_NAME}-logo`}><WalleyLaskuJaOsamaksuLogo /></Icon>*/}
            </div>
        </div>
    );
}
